import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import "./CompetitorConcept.css";
import Img from "react-image";
import DeleteModal from "../../Common/Modal/DeleteModal/DeleteModal";
import Utils from "../../../Utils/Utils";
import { imageConstants, colorConstants } from "../../../config/constants";
import { sortBy } from "lodash";

let selectedValue = {};
const { translate } = Utils;

const CompetitorConceptModal = ({
  showModal,
  handleClose,
  selectedItem,
  saveConcept,
  updateConcept,
  getCompetitorConceptsData,
  competitorsData,
  competitorConceptsData,
}) => {
  const nameRef = React.createRef();
  const [selectedRetailer, setSelectedRetailer] = React.useState(
    selectedItem
      ? {
          retailerId: selectedItem.retailer?.retailerId,
          retailerName: selectedItem.retailer?.retailerName,
        }
      : null
  );
  const [error, setError] = React.useState(false);
  const [duplicateError, setDuplicateError] = React.useState(false);

  React.useEffect(() => {
    setSelectedRetailer(
      selectedItem
        ? {
            retailerId: selectedItem.retailer?.retailerId,
            retailerName: selectedItem.retailer?.retailerName,
          }
        : null
    );
    setError(false);
    setDuplicateError(false);
  }, [selectedItem, showModal]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!selectedRetailer) {
      setError(true);
      return;
    }
    setError(false);
    setDuplicateError(false);

    const enteredName = nameRef.current.value.trim().toLowerCase();

    const nameExists = competitorConceptsData?.some(
      (concept) =>
        concept.name.toLowerCase() === enteredName &&
        concept.retailer?.retailerId === selectedRetailer.retailerId &&
        concept.conceptId !== selectedItem?.conceptId
    );

    if (nameExists) {
      setDuplicateError(true);
      return;
    }

    const payload = {
      name: nameRef.current.value,
      retailer: {
        retailerId: selectedRetailer.retailerId,
        retailerName: selectedRetailer.retailerName,
      },
    };

    const onDone = (status) => {
      if (status) {
        getCompetitorConceptsData();
        handleClose();
      } else {
        setError(true);
      }
    };

    if (selectedItem) {
      updateConcept(selectedItem.conceptId, payload, onDone);
    } else {
      saveConcept(payload, onDone);
    }
  };

  const onModalClose = () => {
    setError(false);
    setDuplicateError(false);
    handleClose();
  };

  return (
    <Modal
      dialogClassName="my-modal"
      show={showModal}
      onHide={onModalClose}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="modal-header" closeButton>
        <Modal.Title className="header">
          {selectedItem ? translate.EditConcept : translate.AddConcept}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group as={Row} controlId="competitorSelect">
            <Form.Label column sm={3}>
              {translate.Competitor}
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                as="select"
                style={{ width: "90%", height: 50 }}
                required
                value={selectedRetailer?.retailerId || ""}
                onChange={(e) => {
                  const found = (competitorsData || []).find(
                    (r) => String(r.retailerId) === e.target.value
                  );
                  setSelectedRetailer(found || null);
                }}
              >
                <option value="">{translate.SelectCompetitor}</option>
                {(competitorsData || []).map((r) => (
                  <option key={r.retailerId} value={r.retailerId}>
                    {r.retailerName}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            controlId="conceptName"
            style={{ paddingTop: 10 }}
          >
            <Form.Label column sm={3}>
              {translate.ConceptName}
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                style={{ width: "90%", height: 50 }}
                required
                ref={nameRef}
                defaultValue={selectedItem?.name || ""}
                type="text"
                placeholder={translate.ConceptName}
              />
              {duplicateError && (
                <p
                  style={{
                    fontSize: 14,
                    color: colorConstants.redColor,
                    paddingTop: 10,
                  }}
                >
                  {translate.ConceptExist}
                </p>
              )}
            </Col>
          </Form.Group>
          {error && (
            <p
              style={{
                fontSize: 14,
                color: colorConstants.redColor,
                paddingTop: 6,
              }}
            >
              {translate.errorMessage}
            </p>
          )}
          <Form.Group as={Row} style={{ paddingTop: 10 }}>
            <Form.Label column sm={2} />
            <Col sm={2}>
              <Button
                type="submit"
                className="btn save-store"
                style={{
                  width: 100,
                  fontWeight: "bold",
                  backgroundColor: colorConstants.themeColor,
                }}
              >
                {translate.saveText}
              </Button>
            </Col>
            <Col sm={2} style={{ paddingLeft: 40 }}>
              <Button
                onClick={onModalClose}
                style={{
                  width: 100,
                  fontWeight: "bold",
                  backgroundColor: colorConstants.whiteColor,
                }}
              >
                <span style={{ color: colorConstants.themeColor }}>
                  {translate.cancelText}
                </span>
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const CompetitorConcept = (props) => {
  const [show, setShow] = useState(false);
  const [deleteModalFlag, setDeleteModal] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleDeleteShow = () => setDeleteModal(true);
  const handleDeleteClose = () => setDeleteModal(false);

  return (
    <div className="bottom-div">
      <div className="d-flex flex-row justify-content-between">
        <p className="custom-store">{translate.competitorConcept}</p>
        <div>
          <Button
            className="btn add-store"
            onClick={() => {
              selectedValue = false;
              handleShow();
            }}
          >
            <Img
              style={{ width: 25, height: 24, marginRight: 10 }}
              src={imageConstants.buttonIcon}
            />
            <span className="custom-class">{translate.AddConcept}</span>
          </Button>
        </div>
      </div>
      <CompetitorConceptModal
        showModal={show}
        handleClose={handleClose}
        selectedItem={selectedValue || null}
        saveConcept={props.saveConcept}
        updateConcept={props.updateConcept}
        getCompetitorConceptsData={props.getCompetitorConceptsData}
        competitorsData={props.competitorsData}
        competitorConceptsData={props.competitorConceptsData}
      />
      <DeleteModal
        showModal={deleteModalFlag}
        handleClose={() => handleDeleteClose()}
        confirmDelete={() => {
          props.deleteCompetitorConcept(selectedValue.conceptId, (status) => {
            if (status) {
              props.getCompetitorConceptsData();
              handleDeleteClose();
            }
          });
          selectedValue = {};
        }}
      />
      <table className="table table-borderless custom-table">
        <thead>
          <tr>
            <th scope="col">S.No</th>
            <th scope="col" className="w-44">
              {translate.ConceptName}
            </th>
            <th scope="col" className="w-44">
              {translate.CompetitorName}
            </th>
            <th scope="col">{translate.actionText}</th>
          </tr>
        </thead>
        <tbody>
          {props.competitorConceptsData &&
            sortBy(props.competitorConceptsData, "conceptId").map(
              (item, index) => (
                <tr
                  key={index}
                  className="shadow-sm rounded bg-white custom-border ml-1 mr-2 p-1 mb-2"
                >
                  <td>{index + 1}</td>
                  <td style={{ textTransform: "capitalize" }}>{item.name}</td>
                  <td style={{ textTransform: "capitalize" }}>
                    {item.retailer?.retailerName}
                  </td>
                  <td className="action-css">
                    <div
                      className="Rounded-Rectangle-14 rounded cursor"
                      onClick={() => {
                        selectedValue = item;
                        handleShow();
                      }}
                    >
                      <Img
                        decode={false}
                        src={imageConstants.editIcon}
                        className="Forma-1"
                      />
                    </div>
                    <div
                      className="Rounded-Rectangle-14-delete rounded cursor"
                      onClick={() => {
                        selectedValue = item;
                        handleDeleteShow();
                      }}
                    >
                      <Img
                        decode={false}
                        src={imageConstants.deleteIcon}
                        className="Forma-1-delete"
                      />
                    </div>
                  </td>
                </tr>
              )
            )}
        </tbody>
      </table>
    </div>
  );
};

export default CompetitorConcept;
